import { render, staticRenderFns } from "./PengurusPusat.vue?vue&type=template&id=57138f34"
import script from "./PengurusPusat.vue?vue&type=script&lang=js"
export * from "./PengurusPusat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports